import { gql } from "@apollo/client";

export const CLIP_REQUEST = gql`
  query GetClip($clipIdentifier: String) {
    getClip(clipIdentifier: $clipIdentifier) {
      _id
      partner {
        useCase
      }
      personalizations {
        cards {
          _id
          ui {
            title
          }
          facet {
            type
          }
        }
      }
      user {
        _id
        admin
        avatar
        userGroup {
          type
        }
        discord {
          avatar
          id
          username
        }
        faceit {
          nickname
        }
        tiktok {
          display_name
          avatar
        }
        scope
        rank
        discordSignUp
        emailVerified
        createdDate
      }
      userClipTitle
      clipTitle
      clipSizeBytes
      status
      onDemand
      campaign {
        campaignBlurbs {
          clip {
            text
            linkText
            linkUrl
            image
          }
        }
      }

      mobile {
        status
        clipLink
        aspectRatio
        resolution
        cf {
          hls
          dash
          thumbnail
          downloadUrl
          readyToStream
        }
        clipImageThumb
      }
      game
      clipLength
      remix {
        isRemixed
        originalUser
        originalClip
        clonedVersion
        ui {
          username
          discordId
          userRank
          userGroup
          shareId
          allstarAvatar
          clipThumbnail
        }
      }
      views
      shareId
      username
      createdDate
      clipImageSource
      clipImageThumb
      clipLinkHLS
      clipLink
      clipSnapshot
      isRemixable
      cf {
        hls
        readyToStream
        downloadUrl
      }
      comments {
        count
        reaction
      }
      clipProperties {
        _id
        displayType
        key
        category
        value
      }
    }
  }
`;

export const IFRAME_CLIP_REQUEST = gql`
  query GetClip($clipIdentifier: String, $partnerRequestedBy: String) {
    getClip(
      clipIdentifier: $clipIdentifier
      partnerRequestedBy: $partnerRequestedBy
    ) {
      _id
      id
      status
      clipTitle
      userClipTitle
      game
      playerGameIdentifier
      clipLength
      views
      shareId
      username
      onDemand
      partner {
        useCase
        partnerId {
          displayName
          defaultProfile
          partnerId
        }
      }
      steamHandle
      steamId64
      createdDate
      clipImageSource
      clipImageThumb
      clipLinkHLS
      clipLink
      clipSnapshot
      remix {
        isRemixed
      }
      mobile {
        status
        clipLink
        aspectRatio
        resolution
        cf {
          hls
          dash
          readyToStream
          thumbnail
          downloadUrl
        }
        clipImageThumb
      }
      cf {
        hls
        dash
        readyToStream
        thumbnail
        downloadUrl
      }
      creative
      user {
        id
        _id
      }
    }
  }
`;
export const MONTAGE_REQUEST = gql`
  query GetMontage($clipIdentifier: String!) {
    getMontage(clipIdentifier: $clipIdentifier) {
      user {
        _id
        admin
        avatar
        userGroup {
          type
        }
        discord {
          username
          id
          avatar
        }
        scope
        rank
        createdDate
        username
      }
      originalClips {
        _id
        user {
          _id
          avatar
          userGroup {
            type
            active
          }
          rank
          username
          discord {
            avatar
            id
            username
          }
        }
        isRemixable
        userClipTitle
        clipTitle
        game
        clipLength
        views
        shareId
        username
        createdDate
        clipImageSource
        clipImageThumb
        clipLinkHLS
        clipLink
        clipSnapshot
        comments {
          count
          reaction
        }
        cf {
          hls
          dash
          thumbnail
          downloadUrl
          readyToStream
        }
        remix {
          isRemixed
          originalUser
          originalClip
          ui {
            username
            discordId
            userRank
            userGroup
            shareId
            allstarAvatar
            clipThumbnail
          }
        }
        mobile {
          status
          clipLink
          aspectRatio
          resolution
          clipImageThumb
          cf {
            hls
            downloadUrl
          }
        }
      }
      cf {
        hls
        dash
        readyToStream
        thumbnail
        downloadUrl
      }
      views
      shareId
      username
      createdDate
      clipImageSource
      clipImageThumb
      clipLinkHLS
      clipLink
      clipSnapshot
      clipTitle
      userClipTitle
    }
  }
`;
